import { render, staticRenderFns } from "./CommentCreate.vue?vue&type=template&id=ccb97b0e&scoped=true&"
import script from "./CommentCreate.vue?vue&type=script&lang=js&"
export * from "./CommentCreate.vue?vue&type=script&lang=js&"
import style0 from "./CommentCreate.vue?vue&type=style&index=0&id=ccb97b0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb97b0e",
  null
  
)

export default component.exports